// 路由配置
import { Suspense, FC, useEffect, useState, ReactNode, CSSProperties } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';

import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Modal, Spin, } from 'antd';
import { Layout } from '@/layout';
import { urlParams } from '@lhb/func';

import { routersConfig } from '@/router/router';
import { onNavigate } from '@/common/document-event/on';
import RouterControl from './router/control'; // 路由守卫
import NotFound from '@/common/components/NotFound';
import { useCustomerInfo } from './hooks';
import { dispatchNavigate } from '@/common/document-event/dispatch';
import KeepAlive from 'react-activation';
import { UserInfoProvider } from '@/index';
import { useOverscrollNone } from '@lhb/hook';
import CustomNotification from './layout/components/CustomNotification';
import CustomMessage from './layout/components/CustomMessage';
import eventLib from 'src/common/document-event/index';
import { getCookie, getStorage, setStorage } from '@lhb/cache';
import { get } from './common/request';
import { getModule } from './api/customer';
import ImModal from './common/components/IM/ImModal';
import { getResourceConfig } from './common/api/common';


// const keepAlives = ['/placeMng', '/pointMng', '/adsMng', 'bunksMng', '/caseMng', '/takeOffAudit', '/labelAudit', '/supplierMng', '/labelSet', '/roleSet', '/reviewApprove'];
const keepAlives: any = [];

const routeList = routersConfig(); // 不能在jsx内执行，需要在Main函数之前就调用，才能获取到正确的页面组件
const map = new Map();

routeList.forEach(item => {
  map.set(item.path, { component: <item.component/>, meta: item.meta, path: item.path });
});

const spinStyle = { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };

const Main: FC<any> = () => {
  useOverscrollNone(); // 锁定pc触控板左右滑翻页事件,防止抽屉打开时返回造成抽屉关闭问题
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const [items, info, parentKeysMap] = useCustomerInfo();
  const [element, setElement] = useState<ReactNode>();
  const [selectKeys, setSelectKeys] = useState<string[]>([location.pathname]);
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const [crumbs, setCrumbs] = useState<any[]>([]);
  const [contactUrl, setContactUrl] = useState<any>();
  const [showIM, setShowIM] = useState<boolean>(false);
  const [needReOpen, setNeedReOpen] = useState<boolean>(false); // 关闭抽屉后是否需要重新打开im
  const [companies, setCompanies] = useState<any>([]); // 当前用户关联的租户
  const [modules, setModules] = useState<any>([]);
  const originurl = process.env.IM_URL;
  const customToken = window.customToken || 'newPmsToken';
  const token = getCookie(customToken) || getStorage(customToken);

  const onSelect = ({ selectedKeys }) => {
    setSelectKeys(selectedKeys);
    getMeta(selectKeys[0]);
    selectedKeys.length && dispatchNavigate(selectedKeys[0]);
  };

  const query: any = urlParams(location.search) || {};

  const getMeta = (pathname: string) => {
    const arr = pathname.split('/');
    const newCrumbs: any = [];
    let str: string = '';
    arr.slice(1,).forEach(item => {
      str += `/${item}`;
      const route = map.get(str);
      const { meta = {}, path } = route || {};

      let crumbs = meta ? meta.crumbs : [];

      /* 路由中配置 otherCrumbs 时，query['from'] 成功匹配则生效，如
        otherCrumbs: { 'sale': [{ title: '采购合同', path: '/contract/sale' }] }
       */
      const otherCrumbs = meta.otherCrumbs && meta.otherCrumbs[query['from']];
      if (Array.isArray(otherCrumbs) && otherCrumbs.length) {
        crumbs = otherCrumbs; // 优先使用匹配到的 otherCrumbs
      }

      if (Array.isArray(crumbs) && crumbs.length) {
        newCrumbs.push(...crumbs);
      }
      meta.title && path && newCrumbs.push({ title: meta.title, path: path, disabled: meta.disabled || pathname === str });
    });
    setCrumbs(newCrumbs);
  };

  const onOpenChange = (openKeys: string[]) => {
    setOpenKeys(openKeys);
  };

  /**
   * @description: 获取 key 关联的父级导航数组
   * @param {string} childkey 路由 key
   * @return {*}
    let parentKeysMap = new Map([
      ['/placeMng', '/resource'],
      ['/pointMng', '/resource'],
      ['/caseMng', '/resource'],
      ['/takeOffAudit', '/audit'],
      ['/con', '/contract'], // 触发循环
      ['/contract', '/con'],
      ['/contractSet', '/contract'],
      ['/contractSetting', '/contractSet']
    ]);

    getParentKeysByChildKeys('/contractSetting'); // ['/contractSet', '/contract', '/con']
   */
  const getParentKeysByChildKeys = (childkey: string) => {
    const keys: any = [];
    let index = 0;
    let key: any = childkey;
    // 防止循环：keys.includes 如果不存在才继续，且小于 10 层
    while (parentKeysMap.has(key) && !keys.includes(parentKeysMap.get(key)) && index < 10) {
      key = parentKeysMap.get(key);
      key && keys.push(key);
      index++;
    }

    return keys;
  };

  // 获取展开的父级导航数组
  const openParentKeys = (childkey: string) => {
    const parentKeys = getParentKeysByChildKeys(childkey);
    if (Array.isArray(parentKeys)) {
      onOpenChange([...openKeys, ...parentKeys]);
      return;
    }
  };

  const getUserCompanies = async () => {
    const res = await get('/property/user/companies', null, true);
    setCompanies(res || []);
  };

  const getOriginModule = async () => {
    const res = await getModule();
    setModules(res);
  };

  const getConfig = async () => {
    const { displayPlaceSupplierOption, displayMetroLineOption } = await getResourceConfig();

    setStorage('hasContactTab', displayPlaceSupplierOption);
    setStorage('hasMetroLine', displayMetroLineOption);

  };

  useEffect(() => {
    // 如果想要导航正常展开、匹配，需要接口设置的导航（pathname）以及父级导航（parentKeysMap）和页面一致
    openParentKeys(pathname);
    setSelectKeys([pathname]);
    getMeta(pathname);
  }, [pathname, parentKeysMap]);

  useEffect(() => {
    onNavigate((path :any) => {
      navigate(path);
      window.scrollTo(0, 0);
    });
  }, []);

  useEffect(() => {
    if (!token) return;
    getUserCompanies();
    getOriginModule();
    getConfig();
  }, [token]);

  /**
   * @description IM弹窗事件的处理
   */
  useEffect(() => {
    eventLib.on('OPEN_MICROIM', (url?: any) => {
      if (url) {
        setContactUrl(url);
        setShowIM(true);
      } else {
        if (needReOpen) {
          setContactUrl(`${originurl}/#/home?source=pms&token=${token}&contact_id=&resource_id=&requirement_id=&mode=pc}`);
          setNeedReOpen(false);
          setShowIM(true);
        }
      }
    });
    eventLib.on('CLOSE_MICROIM', (needReOpen: boolean = false) => {
      if (showIM) {
        setNeedReOpen(needReOpen);
      };
      setShowIM(false);
    });
  }, []);


  useEffect(() => {
    // 获取拥有权限的路由;
    // 考虑到文件顺序，因此只能通过已经获取的路由进行遍历
    if (pathname !== '/') {
      return;
    }
    const getFirstRouer = () => {
      const arr = Array.from(parentKeysMap);
      for (let i = 0; i < arr.length; i++) {
        const [key] = arr[i];
        if (map.has(key)) {
          return { element: map.get(key).componnet, key };
        }
      }
      return null;
    };

    const { element, key = '/' } = getFirstRouer() || {};
    setElement(element);
    setSelectKeys([key as any]);
    dispatchNavigate(key as any);
    setOpenKeys([parentKeysMap.get(key as any)] as any);
  }, [parentKeysMap, pathname]);

  // console.log(document.body);

  const [modal, contextHolder] = Modal.useModal();
  window.microModal = modal;
  return (
    <UserInfoProvider.Provider value={{ info, modules, companies }}>
      {
        window.__POWERED_BY_QIANKUN__
          ? <Layout
            items={items}
            info={info}
            onSelect={onSelect}
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            selectKeys={selectKeys}
            crumbs={crumbs}
            inMicro={true}
          >
            <Suspense fallback={<Spin style={spinStyle as CSSProperties} />}>
              <TransitionGroup component={null}>
                <CSSTransition key={location.pathname} classNames='fade' timeout={300}>
                  <Routes location={location}>
                    <Route path='/' element={element}></Route>
                    {routeList.map((item) => (
                      <Route key={item.path} path={item.path} element=
                        {
                          keepAlives.includes(item.path) ? (
                            <KeepAlive name={location.pathname}>
                              <item.component location={location} />
                            </KeepAlive>
                          )
                            : <item.component location={location} />
                        }
                      ></Route>
                    ))}
                    {/* 匹配找不到的路由 */}
                    <Route path='*' element={<NotFound />}></Route>
                  </Routes>
                </CSSTransition>
              </TransitionGroup>
            </Suspense>
          </Layout>
          : <RouterControl
            routeList={routeList} locationTo={location}>
            <Layout
              items={items}
              info={info}
              onSelect={onSelect}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              selectKeys={selectKeys}
              crumbs={crumbs}
              inMicro={false}
            >
              <Suspense fallback={<Spin style={spinStyle as CSSProperties} />}>
                <TransitionGroup component={null}>
                  <CSSTransition key={location.pathname} classNames='fade' timeout={300}>
                    <Routes location={location}>
                      <Route path='/' element={element}></Route>
                      {routeList.map((item) => (
                        <Route key={item.path} path={item.path} element=
                          {
                            keepAlives.includes(item.path) ? (
                              <KeepAlive>
                                <item.component location={location} />
                              </KeepAlive>
                            )
                              : <item.component location={location} />
                          }
                        ></Route>
                      ))}
                      {/* 匹配找不到的路由 */}
                      <Route path='*' element={<NotFound />}></Route>
                    </Routes>
                  </CSSTransition>
                </TransitionGroup>
              </Suspense>
            </Layout>
          </RouterControl>
      }
      {/* 为微应用挂载ant-notification和 ant-message */}
      <CustomNotification/>
      <CustomMessage/>
      {showIM ? <ImModal setShowIM={setShowIM} contactUrl={contactUrl}/> : <></>}

      {contextHolder}
    </UserInfoProvider.Provider>
  );
};

export default Main;
